import apiClient from './apiClient';

const API_URL = '/divisiones-primarias';

// Obtener divisiones por provincia
export const getDivisionesPorProvincia = async (provinciaId) => {
    const response = await apiClient.get(`${API_URL}/provincia/${provinciaId}`);
    return response.data;
};

